import { render, staticRenderFns } from "./statusDuration.vue?vue&type=template&id=e155de02"
import script from "./statusDuration.vue?vue&type=script&lang=js"
export * from "./statusDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports